import type { LinariaClassName } from '@linaria/core';
import { cx } from '@linaria/core';
import { memo } from 'react';
import "./New.linaria.module.css!=!./New?./New.linaria.module.css?css=H4sIAAAAAAAAA2XPTW7DIBCG4X1Pki6IRF3lhx4GYTzYpGMGwTixi3L3KpViBXf5ar5nMXvDoz6iluinORZLSEldTdoJQcmEHsTo7PvX/W3/GDqr5XCgy/SzyXKZMnu3CEuBIbCyEBjS0w0VW6sY9H0QnmHMG2GzPoVGfrR1FUeBxQ18P7BqCbvnHknz+XPhXFeJput86AVTVDLO6xyqOWznLTHTWIlvLfHYNiZtcjUIjlXzIrAW+E+kvzdeyDlryfPNX7F0Pkc0i3IIj/MvHkkFq6gBAAA="
interface NewBadgeProps {
  className?: LinariaClassName;
}
const newBadgeStyles = "atm_7l_1liuxp atm_fc_1h6ojuz atm_h_1h6ojuz atm_cs_8n312b atm_lo_t94yts atm_le_t94yts atm_lk_1l7b3ar atm_ll_1l7b3ar atm_9s_1txwivl";
const NewBadge = memo((props: NewBadgeProps) => {
  const {
    className
  } = props;
  return <div data-testid="Badge__NewModel" className={cx(newBadgeStyles, className)}>
            NEW
        </div>;
});
export default NewBadge;
export { NewBadge };